import { Link } from 'react-router-dom';

export default function Footer() {
  const footerLinks = {
    快速导航: [
      { to: '/', label: '首页' },
      { to: '/category', label: '分类浏览' },
      { to: '/about', label: '关于我们' },
    ],
    分类推荐: [
      { to: '/category?tab=guide', label: '使用指南' },
      { to: '/category?tab=address', label: '最新地址' },
      { to: '/category?tab=safety', label: '安全须知' },
      { to: '/category?tab=faq', label: '常见问题' },
    ],
    帮助支持: [
      { to: '/about#contact', label: '联系我们' },
      { to: '/category?tab=faq', label: '帮助中心' },
      { to: '/category?tab=guide', label: '使用教程' },
    ],
  };

  const socialLinks = [
    { icon: 'ri-weibo-line', label: '微博', href: '#' },
    { icon: 'ri-wechat-line', label: '微信', href: '#' },
    { icon: 'ri-telegram-line', label: 'Telegram', href: '#' },
    { icon: 'ri-mail-line', label: '邮箱', href: '#' },
  ];

  return (
    <footer className="bg-accent-900 text-background-50">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="text-xl font-bold font-serif">
                91n<span className="text-primary-400">官方入口</span>
              </span>
            </Link>
            <p className="text-sm text-background-50/70 leading-relaxed">
              91n是您值得信赖的内容平台，提供91n最新入口、官方地址及使用指南。
              收藏本页获取实时更新地址，安全稳定访问91n无忧。
            </p>
            <div className="flex items-center gap-3 mt-4">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500 transition-colors duration-200 cursor-pointer"
                  aria-label={social.label}
                  rel="nofollow"
                >
                  <i className={`${social.icon} text-sm`} />
                </a>
              ))}
            </div>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold mb-4 text-background-50">
                {title}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {links.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/40">
            &copy; {new Date().getFullYear()} 91n官方入口 版权所有 | 本站为91n官方导航站
          </p>
          <div className="flex items-center gap-4 text-xs text-background-50/40">
            <a href="#" className="hover:text-background-50/70 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="hover:text-background-50/70 transition-colors cursor-pointer">服务条款</a>
            <a href="#" className="hover:text-background-50/70 transition-colors cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}